/**
 * DetailItemValueContainer component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled detail item value container.
 */
const DetailItemValueContainer = styled.div<React.CSSProperties>`
  color: ${Colors['text']};
  font-family: ${Fonts['light']};
  font-size: ${32 * Screen.widthRatio}px;
  line-height: ${40 * Screen.widthRatio}px;
  width: ${518 * Screen.widthRatio}px;
`;

export default DetailItemValueContainer;
